<template>
  <v-dialog v-model="show" max-width="500px" persistent>
    <v-card>
      <v-toolbar dense outlined>
        <span class="text-subtitle-1">
          Library
          <v-chip class="ml-2" x-small color="primary">
            {{ showUpdateOrEdit ? 'Update' : 'New' }}
          </v-chip>
        </span>
        <v-spacer></v-spacer>
        <v-btn icon @click="close">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>

      <v-form lazy-validation v-model="valid" ref="libraryForm" class="pa-3">
        <v-text-field
          v-model="libraryName"
          hide-details
          clearable
          dense
          outlined
          prepend-inner-icon="mdi-book"
          :rules="rules"
          label="Library name"
        />
        <v-textarea
          v-model="description"
          hide-details
          clearable
          dense
          auto-grow
          outlined
          label="Description"
          class="mt-6"
        />

        <v-file-input
          v-model="image"
          accept="image/*"
          outlined
          dense
          label="Upload image"
          prepend-inner-icon="mdi-image"
          show-size
          clearable
          class="mt-6"
        />

        <v-text-field
          v-model="organizations"
          label="Organization"
          outlined
          dense
          clearable
          prepend-inner-icon="mdi-domain"
        />

        <v-combobox
          class="mb-4"
          v-model="labels"
          label="Labels"
          outlined
          dense
          multiple
          clearable
          deletable-chips
          small-chips
          chips
          hide-details
          hint="Press enter after each version to add"
          prepend-inner-icon="mdi-tag"
        />

        <v-combobox
          v-model="versions"
          label="Versions"
          outlined
          dense
          multiple
          clearable
          deletable-chips
          small-chips
          chips
          hide-details
          hint="Press enter after each version to add"
          prepend-inner-icon="mdi-tag"
        />

        <v-col cols="6">
          <div class="d-flex align-center" style="height: 100%;">
            <v-checkbox
              v-model="isPopular"
              label="Is Popular"
              dense
              hide-details
              class="ma-0 pa-0"
            />
          </div>
        </v-col>

        <div class="d-flex justify-end mt-2">
          <v-btn
            color="primary"
            @click="submit"
            :disabled="!valid || loading"
            :loading="loading"
          >
            {{ showUpdateOrEdit ? 'Update' : 'Save' }}
          </v-btn>
        </div>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import Swal from 'sweetalert2'
import { apiService } from '../../service/api.service'
import environment from '../../../environment'
export default {
  name: 'AddLibraryView',
  props: {
    show: Boolean,
    showUpdateOrEdit: Boolean
  },
  data () {
    return {
      libraryName: '',
      isPopular: false,
      organizations: '',
      image: null,
      description: '',
      labels: '',
      parentCategory: '',
      versions: [],
      valid: true,
      loading: false,
      rules: [
        v => !!v || 'This field is required.'
      ]
    }
  },
  methods: {
    resetForm () {
      this.libraryName = ''
      this.description = ''
      this.labels = ''
      this.isPopular = false
      this.organizations = null
      this.image = null
      this.versions = []
    },
    close () {
      this.resetForm()
      this.$emit('update:show', false)
    },
    submit () {
      this.loading = true

      if (!this.libraryName) {
        Swal.fire('Warning!', 'Library name cannot be empty.', 'warning')
        this.loading = false
        return
      }

      const formData = new FormData()
      formData.append('parent_exp_name', this.libraryName)
      formData.append('description', this.description)
      formData.append('isPopular', this.isPopular)
      formData.append('organizations', this.organizations)
      formData.append('labels', this.labels)
      formData.append('file', this.image)

      apiService
        .post('admin/add-exp-parent', formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        })
        .then((parentResp) => {
          if (!parentResp.data.ok) {
            throw new Error(parentResp.data.message || 'Parent couldn’t be created')
          }

          const parentId = parentResp.data.id

          if (!parentId) {
            throw new Error('Parent ID info couldn’t be found')
          }

          const promises = this.versions.map(version => {
            return apiService.post('admin/add-exp-child', {
              parent_exp_docker_id: parentId,
              setting_name: version
            })
          })

          return Promise.all(promises)
        })
        .then((childResponses) => {
          Swal.fire('Success!', 'Parent and versions added.', 'success')
          this.close()
        })
        .catch((error) => {
          console.error('Operation error:', error)
          Swal.fire('Error!', error.response?.data?.message || error.message, 'error')
        })
        .finally(() => {
          this.loading = false
        })
    }

  }
}
</script>
